<div [ngClass]='orientation == "horizontal" ? "vm-radio-check-list vm-radio-check-list--horizontal":"vm-radio-check-list"'>
  <ng-container *ngIf="!isPrimitiveDatasource; then complex_data; else non_complex_data">
  </ng-container>
  <ng-template #non_complex_data>
    <div class="form-check vm-checkbox" [ngClass]="isdisabled ? 'vm-checkbox--disabled-with-check' : ''"
         *ngFor='let item of bckupdatasource;let i = index'>
      <input class="form-check-input" (focus)='onTouched()' type="checkbox" name="{{name}}" id="chk_{{name}}_{{i}}"
             value="{{item.value}}" [disabled]="isdisabled" (click)="item.checked=!item.checked; onItemClick(item)"
             [(ngModel)]='item.checked'>
      <label class="form-check-label" for="chk_{{name}}_{{i}}">
        {{item.value}}
        <div *ngIf='orientation == "vertical" && i== 0 && helpText!=undefined' [ngClass]="gethelpClass()"
             pTooltip="{{helpText}}"><span class="material-symbols-outlined vm-icon">help</span></div>
        <small *ngIf='orientation == "vertical" && i== 0 && hintText!=undefined'
               [ngClass]="gethintClass()">{{hintText}}</small>
      </label>
      <div *ngIf='orientation == "horizontal" && i== bckupdatasource.length-1 && helpText!=undefined'
           [ngClass]="gethelpClass()" pTooltip="{{helpText}}">
        <span class="material-symbols-outlined vm-icon">help</span>
      </div>
      <small *ngIf='orientation == "horizontal" && i== bckupdatasource.length-1 && hintText!=undefined'
             [ngClass]="gethintClass()">{{hintText}}</small>
    </div>
  </ng-template>
  <ng-template #complex_data>
    <div class="form-check vm-checkbox" [ngClass]="isdisabled ? 'vm-checkbox--disabled-with-check' : ''"
         *ngFor='let item of bckupdatasource;let i = index'>
      <input class="form-check-input" (focus)='onTouched()' type="checkbox" name="{{name}}" id="chk_{{name}}_{{i}}"
             value="{{item[valuefield]}}" [disabled]="isdisabled" (click)="item.checked=!item.checked;onItemClick(item)"
             [(ngModel)]='item.checked' required>
      <label class="form-check-label" for="chk_{{name}}_{{i}}">
        {{item[textfield]}}
        <div *ngIf='orientation == "vertical" && i== 0 && helpText!=undefined' [ngClass]="gethelpClass()"
             pTooltip="{{helpText}}"><span class="material-symbols-outlined vm-icon">help</span></div>
        <small *ngIf='orientation == "vertical" && i== 0 && hintText!=undefined'
               [ngClass]="gethintClass()">{{hintText}}</small>
      </label>

      <div *ngIf='orientation == "horizontal" && i== bckupdatasource.length-1 && helpText!=undefined'
           [ngClass]="gethelpClass()" pTooltip="{{helpText}}">
        <span class="material-symbols-outlined vm-icon">help</span>
      </div>
      <small *ngIf='orientation == "horizontal" && i== bckupdatasource.length-1 && hintText!=undefined'
             [ngClass]="gethintClass()">{{hintText}}</small>
    </div>

  </ng-template>
</div>
